module.exports = __webpack_public_path__ + "media/images/gifts/open_end/sug_aberto_6-3ba6e77332af7a0126d45d782c7de10d.jpg";